module.exports = __webpack_public_path__ + "static/media/Intro to Security Engineering.49b1d265.png";